import { useContext } from 'react';

import { IconLockOutline, Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import { FreemiumContext } from '../../../Freemium/context';

import { StyledBackgroundDiv } from './StyledComponents';

const PremiumUpgrade = () => {
  const { freemiumState } = useContext(FreemiumContext);

  const handleUnlockClick = () => {
    const element = freemiumState.featuresOfPremiumRef?.current;
    if (element) {
      const offsetPosition = element.offsetTop - 100;

      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <Spacer onClick={handleUnlockClick}>
      <StyledBackgroundDiv>
        <IconLockOutline fontColor="textMedium" size="sm" />
        <Text asChild textStyle="body-sm" color="text.subtle" css={{ marginLeft: '200' }}>
          <a>Upgrade for competitive market insights</a>
        </Text>
      </StyledBackgroundDiv>
    </Spacer>
  );
};

export default PremiumUpgrade;
